import type { Country } from '@skippay/core/@types/country';
import type { Attrs } from '@skippay/core/utils/objectUtils';

import { JarabotContactAttributes, jarabotClient } from '../jarabotClient';
import type { JarabotIdentity } from './types';

export const pushCustomAttributes = (attrs: Attrs): void => {
	if (Object.keys(attrs).length === 0) return;
	try {
		jarabotClient.setCustomAttributes(attrs);
	} catch {
		// silently swallow, no error needed
	}
};

export const pushIdentity = (identity: JarabotIdentity, country: Country): void => {
	try {
		jarabotClient.setUser(identity.userId, country, {
			name: identity.name,
			email: identity.email,
			phone_number: identity.phone,
			country_code: identity.countryCode,
		});
		const contactAttrs: JarabotContactAttributes = {
			kyc_verified: identity.kycIsOutdated === false,
			'customer.amlLegalReview.isRequested': identity.amlLegalReviewRequested,
		};
		jarabotClient.setCustomAttributes(contactAttrs);
	} catch {
		// silently swallow, no error needed
	}
};
